import type { ReactNode } from 'react';
import './workbench-skeleton.css';

/**
 * The workbench's own shape before it has its documents: CapturePoint's daily workbench as it
 * settles (the document spine with its filter pill and document cards, the paper, the fields
 * panel with its document type and fields, the bottom bar), drawn in the workbench's tokens on
 * the workbench's canvas. Paige holds this over the mount until the App says it has opened
 * (`window.paigeWorkbench.opened`), and the route shows it while the loader runs long, so the
 * move from the dashboard to a job is one transition and never an empty or differently laid-out
 * frame (IMPLEMENTATION.md, sell-ready sprint 2, row 13). No text: it is a shape, not a message.
 */
export function WorkbenchSkeleton(): ReactNode {
  return (
    <div className="paige-workbench-skeleton" role="status" aria-label="Opening the workbench">
      <div className="paige-workbench-skeleton__spine" aria-hidden="true">
        <i className="paige-workbench-skeleton__pill" />
        <i className="paige-workbench-skeleton__card" />
        <i className="paige-workbench-skeleton__card" />
      </div>
      <div className="paige-workbench-skeleton__paper" aria-hidden="true">
        <div className="paige-workbench-skeleton__toolbar">
          <i className="paige-workbench-skeleton__tool" />
          <i className="paige-workbench-skeleton__tool paige-workbench-skeleton__tool--wide" />
        </div>
        <i className="paige-workbench-skeleton__page" />
      </div>
      <div className="paige-workbench-skeleton__fields" aria-hidden="true">
        <i className="paige-workbench-skeleton__label" />
        <i className="paige-workbench-skeleton__select" />
        {Array.from({ length: 6 }, (_, i) => (
          <span key={i} className="paige-workbench-skeleton__field">
            <i className="paige-workbench-skeleton__label" />
            <i className="paige-workbench-skeleton__input" />
          </span>
        ))}
      </div>
      <div className="paige-workbench-skeleton__bar" aria-hidden="true">
        <i className="paige-workbench-skeleton__tool" />
        <i className="paige-workbench-skeleton__tool paige-workbench-skeleton__tool--wide" />
        <i className="paige-workbench-skeleton__tool paige-workbench-skeleton__tool--end" />
      </div>
    </div>
  );
}
